import RetailProducts from '@/components/retail-products';
import TargetProductsUtils from '@/components/target-products/utils';
import { Colors } from '@/components/retail-products/style';

export default class TargetProducts extends RetailProducts {
  styleProperties = {
    productTitleTransform: (title) => {
      const splitted = title.split(' ');
      if (splitted.length < 3) return title;

      const res = `${splitted.slice(0, 2).join(' ')} <br> ${splitted
        .slice(2, splitted.length)
        .join(' ')}`;
      return res;
    }
  };

  onConstruct() {
    this.backgroundColor = Colors.targetBackgroundColor;
    TargetProductsUtils.getProducts().then((products) => {
      this.products = products;
    });
  }
}
